'use client'

import {
  Carousel,
  CarouselContent,
  CarouselItem,
} from '@/components/ui/carousel'
import { useIsMobileClient } from '@/hooks/common/use-device-type'
import { AmazonFeatureCard } from './amazon-feature-card'
import { AmazonFeatureIntroCard } from './amazon-feature-intro-card'

interface Feature {
  type: string
  title: string | React.ReactNode
  description?: string
  imageUrl?: string
  oekoTex?: boolean
}

interface Props {
  features: Feature[]
}

export const AmazonFeatureGridContent = ({ features }: Props) => {
  const isMobile = useIsMobileClient()

  if (isMobile) {
    return (
      <Carousel opts={{ align: 'start' }}>
        <CarouselContent>
          {features.map((feature, index) => (
            <CarouselItem
              key={index}
              className='basis-[80%] will-change-transform'
            >
              {feature.type === 'intro' ? (
                <AmazonFeatureIntroCard title={feature.title} />
              ) : (
                <AmazonFeatureCard
                  title={feature.title}
                  description={feature.description!}
                  imageUrl={feature.imageUrl!}
                  oekoTex={feature.oekoTex}
                />
              )}
            </CarouselItem>
          ))}
        </CarouselContent>
      </Carousel>
    )
  }

  return (
    <div className='grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4'>
      {features.map((feature, index) => {
        if (feature.type === 'intro') {
          return <AmazonFeatureIntroCard key={index} title={feature.title} />
        }
        return (
          <AmazonFeatureCard
            key={index}
            title={feature.title}
            description={feature.description!}
            imageUrl={feature.imageUrl!}
            oekoTex={feature.oekoTex}
          />
        )
      })}
    </div>
  )
}
